import { render, staticRenderFns } from "./RestaurantReviewCard.vue?vue&type=template&id=2204fbb7&scoped=true&"
import script from "./RestaurantReviewCard.vue?vue&type=script&lang=js&"
export * from "./RestaurantReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantReviewCard.vue?vue&type=style&index=0&id=2204fbb7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204fbb7",
  null
  
)

export default component.exports